"use strict";
/**
 * bridge 是和app交互的方法
 * **/
import { queryUrl } from "@/utils/index";

let u = navigator.userAgent;
let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
function setupWebViewJavascriptBridge(callback) {
  //Android使用
  if (isAndroid) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        "WebViewJavascriptBridgeReady",
        function () {
          return callback(window.WebViewJavascriptBridge);
        },
        false
      );
    }
  } else {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    let WVJBIframe = document.createElement("iframe");
    WVJBIframe.style.display = "none";
    WVJBIframe.src = "https://__bridge_loaded__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
}

export function callHandler(CMD, params) {
  return new Promise(function (resolve, reject) {
    try {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge["callHandler"](CMD, params, function (resStr) {
          if (Object.prototype.toString.call(resStr) !== "[object String]") {
            resStr = JSON.stringify(resStr);
          }
          //res 是个字符串
          resolve(resStr);
        });
      });
      // bridge 超时操作
      let timer = setTimeout(() => {
        resolve(queryUrl(location.href));
        clearTimeout(timer);
      }, 10000);
    } catch (e) {
      // 初始化失败
      reject("BRIDGE_LOADED_ERROR");
    }
  });
}

export function registerHandler(CMD, callback) {
  try {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge["registerHandler"](CMD, function (resStr) {
        if (Object.prototype.toString.call(resStr) !== "[object String]") {
          resStr = JSON.stringify(resStr);
        }
        //res 是个字符串
        if (
          Object.prototype.toString.call(callback) === "[object Function]" ||
          Object.prototype.toString.call(callback) === "[object AsyncFunction]"
        ) {
          return callback(resStr);
        }
        console.log("registerHandler参数错误, callback is not a function");
      });
    });
  } catch (e) {
    console.log(e.message);
  }
}

/**
 * 获取用户信息 token  userId managerId， tenantId
 * **/
export function getUserInfo() {
  return callHandler("tbAppUserInfo")
    .then(function (data) {
      data = JSON.parse(data);
      return Promise.resolve(data);
    })
    .catch((e) => {
      return Promise.reject(e);
    });
}
/**
 * 分享功能
 * {
 *   "shareType": "",
 *   "shareTitle": "",
 *   "shareContent": "",
 *   "shareImageUrl": "",
 *   "shareUrl": ""
 * }
 *
 * **/
export function appShare(params) {
  const options = {};
  Object.assign(options, params);
  return callHandler("tbShareSocialPlatform", options);
}
export function shareHeaderBtn(params) {
  const options = {};
  Object.assign(options, params);
  return callHandler("tbShowButton", options);
}
/**
 * 设置页面title
 * **/
export function setTitle(titleStr) {
  return callHandler("tbWebTitle", titleStr);
}
/**
 * h5通过app跳转到别的h5,  参数复制 要深复制
 * **/
export function openH5Page(url, params) {
  const options = {};
  if (typeof url === "object") {
    params = url;
    url = "";
  }
  Object.assign(
    options,
    {
      page: "webview",
      pageParams: {
        url: url,
        login: "1",
      },
    },
    params
  );
  return callHandler("tbH5GoAppPages", options);
}
/**
 * 打开原生页面
 * **/
export function openAppPage(params) {
  return callHandler("tbH5OpenAppPage", {
    ios: params.ios,
    android: params.android,
    flutter: params.flutter,
  });
}
/**
 * 关闭Webview
 * **/
export function closeWebview() {
  return callHandler("tbWapGoBack", "wapCloseWeb");
}
/**
 * bridge 刷新 webview
 * 参数 isRefresh  1刷新，0不刷新
 * **/
export function webViewRefresh(isRefresh) {
  return callHandler("tbReloadWebOnVisible", {
    isReloadWeb: isRefresh,
  });
}
/**
 * 打电话
 * **/
export function phone(num) {
  return callHandler("tbCallPhone", num);
}
/**
 * app调用h5方法,页面局部刷新用
 * **/
export function tbH5Resume(callback) {
  return registerHandler("tbH5Resume", callback);
}
/**
 * h5转发文章页面，粘贴文章链接地址
 * **/
export function tbEditOuterArticle(param) {
  return callHandler("tbEditOuterArticle", { url: param });
}
/**
 * app调用h5方法,页面局部刷新用
 * **/
export function tbCloseExtraAgreement(callback) {
  return registerHandler("tbCloseExtraAgreement", callback);
}
